import { render, staticRenderFns } from "./dialog-forgetpassword.vue?vue&type=template&id=71e78f22&"
import script from "./dialog-forgetpassword.vue?vue&type=script&lang=js&"
export * from "./dialog-forgetpassword.vue?vue&type=script&lang=js&"
import style0 from "./dialog-forgetpassword.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports